"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  HourglassAlternate: ['hourglass-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,22h-1V18.5A7.505,7.505,0,0,0,15.739,12,7.5,7.5,0,0,0,19.5,5.5V2h1a1,1,0,0,0,0-2H3.5a1,1,0,0,0,0,2h1V5.5A7.5,7.5,0,0,0,8.261,12,7.505,7.505,0,0,0,4.5,18.5V22h-1a1,1,0,0,0,0,2h17a1,1,0,0,0,0-2Zm-14-3.5a5.507,5.507,0,0,1,6.051-5.473A5.668,5.668,0,0,1,17.5,18.747V21.5a.5.5,0,0,1-.5.5H7a.5.5,0,0,1-.5-.5ZM7,2H17a.5.5,0,0,1,.5.5V5.256a5.667,5.667,0,0,1-4.949,5.718A5.506,5.506,0,0,1,6.5,5.5v-3A.5.5,0,0,1,7,2Z', 'M12,9.626a4.042,4.042,0,0,0,3.433-2.165A.5.5,0,0,0,15,6.71H9a.5.5,0,0,0-.433.751A4.042,4.042,0,0,0,12,9.626Z', 'M12.748,15.59a1.035,1.035,0,0,0-1.5,0L7.925,19.337A1,1,0,0,0,8.671,21h6.658a1,1,0,0,0,.747-1.664Z']],
  Hourglass1Alternate: ['hourglass-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,11.5a.5.5,0,0,0,.455-.293l2.5-5.5A.5.5,0,0,0,14.5,5h-5a.5.5,0,0,0-.455.707l2.5,5.5A.5.5,0,0,0,12,11.5Z', 'M21,22h-.651l-4.268-8.8a2.734,2.734,0,0,1,0-2.4L20.349,2H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,2h.651l4.268,8.8a2.734,2.734,0,0,1,0,2.4L3.651,22H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2ZM9.269,13.854a4.221,4.221,0,0,0,0-3.7L5.318,2H18.682l-3.951,8.148a4.221,4.221,0,0,0,0,3.705L18.682,22H5.318Z', 'M15.511,20.289l-3.059-6.5a.52.52,0,0,0-.9,0l-3.059,6.5A.5.5,0,0,0,8.941,21h6.118a.5.5,0,0,0,.452-.712Z']],
  StopwatchAlternate: ['stopwatch-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.159,8.257l1.548-1.549a1,1,0,1,0-1.414-1.414l-1.6,1.6A9.448,9.448,0,0,0,13,5.054V2h2a1,1,0,1,0,0-2H9A1,1,0,0,0,9,2h2V5.054a9.5,9.5,0,1,0,8.159,3.2ZM12,22.5a8,8,0,1,1,8-8A8,8,0,0,1,12,22.5Z', 'M12,8a6.5,6.5,0,1,0,6.5,6.5A6.5,6.5,0,0,0,12,8Zm.53,6.822a.759.759,0,0,1-1.06,0L9.428,12.782a.75.75,0,0,1,1.061-1.061l2.041,2.042A.749.749,0,0,1,12.53,14.823Z']],
  TimeClockHand: ['time-clock-hand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.115,14.635a1,1,0,0,0-1,1v7.25a1,1,0,0,0,2,0v-7.25A1,1,0,0,0,1.115,14.635Z', 'M15.615,19.385H6.49a.625.625,0,1,1,0-1.25H9.016a1,1,0,0,0,.919-1.393,2.233,2.233,0,0,0-2.056-1.357H3.615a.5.5,0,0,0-.5.5v6.5a.5.5,0,0,0,.5.5H14.379a2.238,2.238,0,0,0,2.236-2.236v-.264A1,1,0,0,0,15.615,19.385Z', 'M16.115.116a7.769,7.769,0,1,0,7.77,7.769A7.779,7.779,0,0,0,16.115.116Zm0,13.538a5.769,5.769,0,1,1,5.77-5.769A5.775,5.775,0,0,1,16.115,13.654Z', 'M18.577,7.135H16.865V4.808a.75.75,0,0,0-1.5,0V7.885a.75.75,0,0,0,.75.75h2.462a.75.75,0,0,0,0-1.5Z']],
  TimeClockCircle1: ['time-clock-circle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,20.5a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,12,20.5ZM12,13a1,1,0,0,1-.707-.293l-3-3A1,1,0,0,1,9.707,8.294L12.414,11H19a1,1,0,0,1,0,2ZM6,12a1.25,1.25,0,1,1-1.25-1.25A1.25,1.25,0,0,1,6,12Zm6-8.5a1.25,1.25,0,1,1-1.25,1.25A1.25,1.25,0,0,1,12,3.5Z']],
  TimeClockCircle2: ['time-clock-circle-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,4.251A7.75,7.75,0,1,0,19.75,12,7.759,7.759,0,0,0,12,4.251Zm3,9H11.5a.75.75,0,0,1-.75-.75V7a.75.75,0,0,1,1.5,0v4.75H15a.75.75,0,0,1,0,1.5Z', 'M19.5,0H4.5A4.5,4.5,0,0,0,0,4.5v15A4.505,4.505,0,0,0,4.5,24h15A4.505,4.505,0,0,0,24,19.5V4.5A4.5,4.5,0,0,0,19.5,0Zm1.75,12A9.25,9.25,0,1,1,12,2.751,9.26,9.26,0,0,1,21.25,12Z']],
  Stopwatch: ['stopwatch', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.159,8.256l1.548-1.548a1,1,0,1,0-1.414-1.414l-1.6,1.6A9.448,9.448,0,0,0,13,5.053V2h2a1,1,0,1,0,0-2H9A1,1,0,0,0,9,2h2V5.053a9.5,9.5,0,1,0,8.159,3.2ZM12,22a7.5,7.5,0,1,1,7.5-7.5A7.509,7.509,0,0,1,12,22Z', 'M9.207,10.294a1,1,0,0,0-1.414,1.414l3.5,3.5a1.014,1.014,0,0,0,1.414,0,1,1,0,0,0,0-1.414Z']],
  Hourglass1: ['hourglass-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,22h-.929l-4.215-8.693a2.977,2.977,0,0,1,0-2.614L20.071,2H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,2h.929l4.215,8.693a2.977,2.977,0,0,1,0,2.614L3.929,22H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2ZM8.063,4.663A.5.5,0,0,1,8.5,4.407h7a.5.5,0,0,1,.426.762l-3.5,5.688a.5.5,0,0,1-.852,0l-3.5-5.688A.5.5,0,0,1,8.063,4.663Zm3.511,9.482a.52.52,0,0,1,.852,0l3.5,5.687a.5.5,0,0,1-.426.763h-7a.5.5,0,0,1-.426-.763Z']],
  TimeClockSix: ['time-clock-six', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M12,4a.5.5,0,0,0-.5.5v15a.5.5,0,0,0,.5.5A8,8,0,0,0,12,4Z']],
  TimeClockSix1: ['time-clock-six-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,12A12,12,0,1,0,12,0,12.013,12.013,0,0,0,0,12Zm2,0A10,10,0,1,1,12,22,10.011,10.011,0,0,1,2,12Z', 'M12,4a.5.5,0,0,1,.5.5v15a.5.5,0,0,1-.5.5A8,8,0,0,1,12,4Z']],
  TimeStopwatchHalf: ['time-stopwatch-half', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.506,8.689a.25.25,0,0,1,.021-.33l1.651-1.651a1,1,0,1,0-1.414-1.414L18.108,6.95a.25.25,0,0,1-.329.021A9.447,9.447,0,0,0,13.218,5.08.25.25,0,0,1,13,4.832V2.251A.25.25,0,0,1,13.25,2H15a1,1,0,1,0,0-2H9A1,1,0,0,0,9,2h1.75a.25.25,0,0,1,.25.25V4.832a.249.249,0,0,1-.218.248,9.513,9.513,0,1,0,8.724,3.609ZM12,22a7.5,7.5,0,1,1,7.5-7.5A7.508,7.508,0,0,1,12,22Z', 'M12,8.5a.5.5,0,0,0-.5.5V20a.5.5,0,0,0,.5.5,6,6,0,0,0,0-12Z']],
  TimeClockMidnight: ['time-clock-midnight', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M4.000 12.001 A8.000 8.000 0 1 0 20.000 12.001 A8.000 8.000 0 1 0 4.000 12.001 Z']],
  TimeClockNine: ['time-clock-nine', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M12,4a.5.5,0,0,0-.5.5v7h-7A.5.5,0,0,0,4,12a8,8,0,1,0,8-8Z']],
  TimeClockThree: ['time-clock-three', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M12,4a.5.5,0,0,0-.5.5v8a.5.5,0,0,0,.5.5h7.475a.587.587,0,0,0,.5-.55A7.994,7.994,0,0,0,12,4Z']],
  TimeStopwatchQuarter: ['time-stopwatch-quarter', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,8.5a.5.5,0,0,0-.5.5v5.5a.5.5,0,0,0,.5.5h5.5a.5.5,0,0,0,.5-.5A6.006,6.006,0,0,0,12,8.5Z', 'M19.506,8.689a.25.25,0,0,1,.021-.33l1.651-1.651a1,1,0,1,0-1.414-1.414L18.108,6.95a.25.25,0,0,1-.329.021A9.447,9.447,0,0,0,13.218,5.08.25.25,0,0,1,13,4.832V2.251A.25.25,0,0,1,13.25,2H15a1,1,0,1,0,0-2H9A1,1,0,0,0,9,2h1.75a.25.25,0,0,1,.25.25V4.832a.249.249,0,0,1-.218.248,9.513,9.513,0,1,0,8.724,3.609ZM12,22a7.5,7.5,0,1,1,7.5-7.5A7.508,7.508,0,0,1,12,22Z']],
  WatchTime1: ['watch-time-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.266,12.175V9.985a.75.75,0,0,0-1.5,0v2.5a.75.75,0,0,0,.219.53l3,3a.769.769,0,0,0,1.061,0,.749.749,0,0,0,0-1.06Z', 'M23.838,4.163l-4-4a.5.5,0,0,0-.707,0L17.713,1.581a.249.249,0,0,0,0,.353l4.353,4.354a.25.25,0,0,0,.354,0L23.838,4.87A.5.5,0,0,0,23.838,4.163Z', 'M16.3,3,14.306,4.988a7.981,7.981,0,0,0-3.413-.479,8.079,8.079,0,0,0-7.354,7.364,7.988,7.988,0,0,0,.49,3.432L.164,19.13a.5.5,0,0,0-.148.355v4a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.352-.145l3.867-3.854a7.977,7.977,0,0,0,3.409.475,8.08,8.08,0,0,0,7.347-7.346,7.967,7.967,0,0,0-.478-3.42L21.006,7.7a.252.252,0,0,0,0-.354L16.652,3A.249.249,0,0,0,16.3,3Zm-4.783,15.49a6,6,0,1,1,6-6A6.006,6.006,0,0,1,11.516,18.485Zm-8.5,1.5a1,1,0,1,1,1,1A1,1,0,0,1,3.016,19.985Z']],
  WatchTime: ['watch-time', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,12a8.005,8.005,0,0,0-4-6.926V1.5A1.5,1.5,0,0,0,14.5,0h-5A1.5,1.5,0,0,0,8,1.5V5.075A8,8,0,0,0,8,18.927V22.5A1.5,1.5,0,0,0,9.5,24h5A1.5,1.5,0,0,0,16,22.5V18.927A8.006,8.006,0,0,0,20,12Zm-8,6a6,6,0,1,1,6-6A6.007,6.007,0,0,1,12,18Z', 'M12.75,11.69V9a.75.75,0,1,0-1.5,0v3a.749.749,0,0,0,.22.53l2.5,2.5a.77.77,0,0,0,1.06,0,.749.749,0,0,0,0-1.06Z']],
  WatchTimeAlternate: ['watch-time-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,7a5,5,0,1,0,5,5A5.006,5.006,0,0,0,12,7Zm2.53,7.531a.755.755,0,0,1-1.06,0l-2-2A.751.751,0,0,1,11.25,12V10a.75.75,0,1,1,1.5,0v1.69l1.78,1.78A.75.75,0,0,1,14.53,14.532Z', 'M20,12a8,8,0,0,0-3.5-6.61V2a2,2,0,0,0-2-2h-5a2,2,0,0,0-2,2v3.39a7.993,7.993,0,0,0,0,13.221V22a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2V18.612A8,8,0,0,0,20,12Zm-8,6a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,18ZM9.5,2h5V4.4a7.994,7.994,0,0,0-5,0Zm5,20h-5V19.6a8.012,8.012,0,0,0,5,0Z']],
  TimeClockHand1Alternate: ['time-clock-hand-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.071,2.931a10,10,0,0,0-14.142,0A10.06,10.06,0,0,0,4.3,12.425a1,1,0,0,0,1.94-.482,8,8,0,1,1,13.42,3.715,1,1,0,0,0,1.414,1.414,10,10,0,0,0,0-14.141Z', 'M15.5,19.5H6.375a.625.625,0,0,1,0-1.25H8.9a1,1,0,0,0,.919-1.393A2.235,2.235,0,0,0,7.764,15.5H3.5A.5.5,0,0,0,3,16v6.5a.5.5,0,0,0,.5.5H14.264A2.238,2.238,0,0,0,16.5,20.765V20.5A1,1,0,0,0,15.5,19.5Z', 'M1,14.751a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0v-7.25A1,1,0,0,0,1,14.751Z', 'M18,9.5H15v-5a1,1,0,1,0-2,0v6a1,1,0,0,0,1,1h4a1,1,0,0,0,0-2Z']],
  Hourglass: ['hourglass', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,22H19V18.5A7.01,7.01,0,0,0,14.6,12,7.011,7.011,0,0,0,19,5.5V2h1.5a1,1,0,0,0,0-2H3.5a1,1,0,0,0,0,2H5V5.5A7.011,7.011,0,0,0,9.4,12,7.01,7.01,0,0,0,5,18.5V22H3.5a1,1,0,0,0,0,2h17a1,1,0,0,0,0-2ZM8.19,6.92a1,1,0,0,1,.89-.544h5.84a1,1,0,0,1,.811,1.584,4.591,4.591,0,0,1-7.462,0A1,1,0,0,1,8.19,6.92ZM7.92,18.63l3.044-2.936a1.544,1.544,0,0,1,2.07,0l0,0,3.043,2.935a1.349,1.349,0,0,1,.269,1.6,1.461,1.461,0,0,1-1.3.771H8.957a1.46,1.46,0,0,1-1.3-.764A1.352,1.352,0,0,1,7.92,18.63Z']],
  TimeClockCircle2Alternate: ['time-clock-circle-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,0H4.5A4.505,4.505,0,0,0,0,4.5v15A4.5,4.5,0,0,0,4.5,24h15A4.5,4.5,0,0,0,24,19.5V4.5A4.505,4.505,0,0,0,19.5,0Zm1,12A8.5,8.5,0,1,1,12,3.5,8.5,8.5,0,0,1,20.5,12Z', 'M15,11.5H12.5V7a1,1,0,0,0-2,0v5.5a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2Z']],
  TimeClockCircle: ['time-clock-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm5.2,17.221a1.016,1.016,0,0,1-1.413.062l-4.959-4.546A1,1,0,0,1,10.5,12V6.5a1,1,0,0,1,2,0v5.06l4.634,4.248A1,1,0,0,1,17.2,17.222Z']],
  TimeClockCircleAlternate: ['time-clock-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M17.134,15.81,12.5,11.561V6.5a1,1,0,0,0-2,0V12a1,1,0,0,0,.324.738l4.959,4.545a1.01,1.01,0,0,0,1.413-.061A1,1,0,0,0,17.134,15.81Z']],
  TimeClockHand1: ['time-clock-hand-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,10A10,10,0,1,0,4.709,13.686.5.5,0,0,0,5.174,14h2.59A3.733,3.733,0,0,1,11.2,16.267a2.486,2.486,0,0,1,.194,1.192.5.5,0,0,0,.5.542H15.5a2.476,2.476,0,0,1,1.966.975.5.5,0,0,0,.6.151A10.005,10.005,0,0,0,24,10Zm-11,.5v-6a1,1,0,1,1,2,0V9a.5.5,0,0,0,.5.5H18a1,1,0,0,1,0,2H14A1,1,0,0,1,13,10.5Z', 'M6.375,19.5a.625.625,0,0,1,0-1.25H8.9a1,1,0,0,0,.919-1.394A2.234,2.234,0,0,0,7.764,15.5H3.5A.5.5,0,0,0,3,16v6.5a.5.5,0,0,0,.5.5H14.264A2.239,2.239,0,0,0,16.5,20.765V20.5a1,1,0,0,0-1-1Z', 'M2,15.751a.992.992,0,0,0-.267-.669A.99.99,0,0,0,1,14.751a1,1,0,0,0-1,1V23a1,1,0,0,0,1,1,.98.98,0,0,0,.808-.444A.967.967,0,0,0,2,23Z']],
  TimeStopwatch: ['time-stopwatch', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,14.5A9.5,9.5,0,1,0,19.506,8.689a.249.249,0,0,1,.021-.33l1.651-1.651a1,1,0,1,0-1.414-1.414L18.108,6.95a.249.249,0,0,1-.329.021A9.451,9.451,0,0,0,13.218,5.08.249.249,0,0,1,13,4.832V2.251A.25.25,0,0,1,13.25,2H15a1,1,0,1,0,0-2H9A1,1,0,0,0,9,2h1.75a.25.25,0,0,1,.25.25V4.832a.249.249,0,0,1-.218.248A9.513,9.513,0,0,0,2.5,14.5Zm2,0A7.5,7.5,0,1,1,12,22,7.508,7.508,0,0,1,4.5,14.5Z']],
  TimeStopwatchHalf1: ['time-stopwatch-half-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.506,8.689a.25.25,0,0,1,.021-.33l1.651-1.651a1,1,0,1,0-1.414-1.414L18.108,6.95a.25.25,0,0,1-.329.021A9.447,9.447,0,0,0,13.218,5.08.25.25,0,0,1,13,4.832V2.251A.25.25,0,0,1,13.25,2H15a1,1,0,1,0,0-2H9A1,1,0,0,0,9,2h1.75a.25.25,0,0,1,.25.25V4.832a.249.249,0,0,1-.218.248,9.513,9.513,0,1,0,8.724,3.609ZM12,22a7.5,7.5,0,1,1,7.5-7.5A7.508,7.508,0,0,1,12,22Z', 'M12,8.5a.5.5,0,0,1,.5.5V20a.5.5,0,0,1-.5.5,6,6,0,0,1,0-12Z']],
  WatchTime1Alternate: ['watch-time-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.469,7.533a5,5,0,1,0,5,5A5.006,5.006,0,0,0,11.469,7.533ZM14,15.063a.758.758,0,0,1-1.061,0l-2-2a.754.754,0,0,1-.219-.53v-2a.75.75,0,0,1,1.5,0v1.689L14,14A.75.75,0,0,1,14,15.063Z', 'M23.707,5.708a1,1,0,0,0,0-1.414l-4-4a1,1,0,0,0-1.414,0S13.74,4.847,13.73,4.859A8,8,0,0,0,3.8,14.794l-3.5,3.5A1,1,0,0,0,0,19v4a1,1,0,0,0,1,1H5a1,1,0,0,0,.707-.293s3.49-3.49,3.5-3.5a8,8,0,0,0,9.936-9.935Zm-4.53-3.116,2.232,2.232a.25.25,0,0,1,0,.354l-.711.711a.25.25,0,0,1-.354,0L18.112,3.657a.25.25,0,0,1,0-.354l.711-.711A.25.25,0,0,1,19.177,2.592ZM11.469,18.533a6,6,0,1,1,6-6A6.007,6.007,0,0,1,11.469,18.533ZM4.482,22H2.25a.25.25,0,0,1-.25-.25V19.519a.251.251,0,0,1,.073-.177l2.385-2.385a.243.243,0,0,1,.376.04A8.059,8.059,0,0,0,7,19.167a.242.242,0,0,1,.04.376L4.659,21.928A.249.249,0,0,1,4.482,22ZM15.894,5.522l.8-.8a.249.249,0,0,1,.353,0l2.233,2.231a.25.25,0,0,1,0,.354l-.8.805a.244.244,0,0,1-.376-.04,8.059,8.059,0,0,0-2.17-2.17A.243.243,0,0,1,15.894,5.522Z', 'M2.969 20.033 A1.000 1.000 0 1 0 4.969 20.033 A1.000 1.000 0 1 0 2.969 20.033 Z']],
  TimeStopwatch3Quarters: ['time-stopwatch-3-quarters', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.506,8.689a.25.25,0,0,1,.021-.33l1.651-1.651a1,1,0,1,0-1.414-1.414L18.108,6.95a.25.25,0,0,1-.329.021A9.447,9.447,0,0,0,13.218,5.08.25.25,0,0,1,13,4.832V2.251A.25.25,0,0,1,13.25,2H15a1,1,0,1,0,0-2H9A1,1,0,0,0,9,2h1.75a.25.25,0,0,1,.25.25V4.832a.249.249,0,0,1-.218.248,9.513,9.513,0,1,0,8.724,3.609ZM12,22a7.5,7.5,0,1,1,7.5-7.5A7.508,7.508,0,0,1,12,22Z', 'M12,8.5a.5.5,0,0,0-.5.5v5h-5a.5.5,0,0,0-.5.5,6,6,0,1,0,6-6Z']],
  TimeClockFire: ['time-clock-fire', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.534,10.1A8.047,8.047,0,0,0,20.1,4.456a1,1,0,0,0-1.662.649,1.345,1.345,0,0,1-1.456,1.2,4.381,4.381,0,0,1-.878-4.816A1,1,0,0,0,15.234,0c-4.316,0-7.558,2.406-8.506,6.21a1.505,1.505,0,0,1-1-1.147,1,1,0,0,0-1.637-.625,7.419,7.419,0,0,0-2.558,6.578A6.381,6.381,0,0,0,4.685,15.7a.25.25,0,0,0,.218.017.253.253,0,0,0,.149-.162A7.655,7.655,0,0,1,5.6,14.2a.25.25,0,0,0-.087-.324,4.337,4.337,0,0,1-2-3.124,5.425,5.425,0,0,1,.952-3.77A3.646,3.646,0,0,0,7.631,8.3a1,1,0,0,0,.893-.855,5.975,5.975,0,0,1,5.289-5.333,6.336,6.336,0,0,0,2.256,6.018,1,1,0,0,0,.5.172,3.553,3.553,0,0,0,3.1-1.2,5.8,5.8,0,0,1,.866,3.008,3.937,3.937,0,0,1-1.465,3.171.25.25,0,0,0-.052.327,7.651,7.651,0,0,1,.665,1.319.251.251,0,0,0,.382.11A5.916,5.916,0,0,0,22.534,10.1Z', 'M18.726,17.751A6.25,6.25,0,1,0,12.476,24,6.257,6.257,0,0,0,18.726,17.751Zm-2.442,0a.75.75,0,0,1-.75.75h-3a.75.75,0,0,1-.75-.75v-3.5a.75.75,0,0,1,1.5,0v2.5a.25.25,0,0,0,.25.25h2A.75.75,0,0,1,16.284,17.751Z']],
  TimeClockCircle1Alternate: ['time-clock-circle-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M19,11H12.414L9.707,8.294A1,1,0,0,0,8.293,9.708l3,3A1,1,0,0,0,12,13h7a1,1,0,0,0,0-2Z', 'M3.500 12.001 A1.250 1.250 0 1 0 6.000 12.001 A1.250 1.250 0 1 0 3.500 12.001 Z', 'M10.750 4.751 A1.250 1.250 0 1 0 13.250 4.751 A1.250 1.250 0 1 0 10.750 4.751 Z', 'M10.750 19.251 A1.250 1.250 0 1 0 13.250 19.251 A1.250 1.250 0 1 0 10.750 19.251 Z']]
};
exports["default"] = _default;